import { Vector4 } from "../maths/Vector4";
import { Render2DSimple } from "../renders/Render2D";
import { FastSinglelist } from "../utils/SingletonList";
import { Stat } from "../utils/Stat";
export class Batch2DInfo {
    constructor() {
        this.batchFun = null;
        this.batch = false;
        this.indexStart = -1;
        this.elementLenth = 0;
    }
    static create() {
        if (this._pool.length != 0) {
            return this._pool.pop();
        }
        else
            return new Batch2DInfo();
    }
    static recover(info) {
        this._pool.push(info);
    }
}
Batch2DInfo._pool = [];
export class RenderManager2D {
    static regisBatch(renderElementType, batch) {
        if (RenderManager2D._batchMapManager[renderElementType])
            throw "Overlapping batch optimization";
        else
            RenderManager2D._batchMapManager[renderElementType] = batch;
    }
    set renderLayerMask(value) {
        this._renderLayerMask = value;
    }
    set cullRect(value) {
        this._cullRect = value;
    }
    get list() {
        return this._list;
    }
    set list(value) {
        this._list = value;
    }
    constructor() {
        this._lastRenderNodeType = -1;
        this._renderEnd = true;
        this._renderLayerMask = 0xFFFFFFFF;
        this._cullRect = new Vector4();
        this.list = new FastSinglelist();
        this._renderElementList = new FastSinglelist();
        this._batchInfoList = new FastSinglelist();
    }
    addRenderObject(object) {
        this.list.add(object);
    }
    removeRenderObject(object) {
        this.list.remove(object);
    }
    clearList() {
        this._list.clear();
        this._renderElementList.clear();
        for (var i = 0, n = this._batchInfoList.length; i < n; i++) {
            let element = this._batchInfoList.elements[i];
            if (element.batch) {
                element.batchFun.recover();
            }
            Batch2DInfo.recover(element);
        }
        this._batchInfoList.clear();
    }
    renderUpdate() {
        var context = Render2DSimple.rendercontext2D;
        let lists = this._list.elements;
        for (let i = 0, n = this._list.length; i < n; i++) {
            let render = lists[i];
            if (render.renderUpdate && render._renderUpdateMask != Stat.loopCount) {
                render.renderUpdate(context);
                render._renderUpdateMask = Stat.loopCount;
            }
        }
    }
    render(context) {
        this.renderUpdate();
        for (var i = 0, n = this._list.length; i < n; i++) {
            this._cull(this._list.elements[i], context);
        }
        this._batch();
        context.drawRenderElementList(this._renderElementList);
        this.endRender();
    }
    _cull(renderNode, context) {
        if (renderNode.preRenderUpdate)
            renderNode.preRenderUpdate(context);
        let n = renderNode._renderElements.length;
        if (n == 1) {
            this._batchStart(renderNode._renderType, 1);
            this._renderElementList.add(renderNode._renderElements[0]);
        }
        else {
            this._batchStart(renderNode._renderType, n);
            for (var i = 0; i < n; i++) {
                this._renderElementList.add(renderNode._renderElements[i]);
            }
        }
    }
    _isRectIntersect(rect1, rect2) {
        return !(rect1.x > rect2.z || rect1.z < rect2.x || rect1.y > rect2.w || rect1.w < rect2.y);
    }
    _batch() {
        this._batchInfoList.add(this._lastbatch2DInfo);
        this._renderElementList.length = 0;
        for (var i = 0, n = this._batchInfoList.length; i < n; i++) {
            let info = this._batchInfoList.elements[i];
            if (info.batch) {
                info.batchFun.batchRenderElement(this._renderElementList, info.indexStart, info.elementLenth);
            }
            else {
                for (let j = info.indexStart, m = info.elementLenth + info.indexStart; j < m; j++)
                    this._renderElementList.add(this._renderElementList.elements[j]);
            }
        }
    }
    _batchStart(renderNodeType, elementLength) {
        if (this._lastRenderNodeType == -1) {
            this._lastbatch2DInfo = Batch2DInfo.create();
            this._lastbatch2DInfo.batch = false;
            this._lastbatch2DInfo.batchFun = RenderManager2D._batchMapManager[renderNodeType];
            this._lastbatch2DInfo.indexStart = 0;
            this._lastbatch2DInfo.elementLenth = elementLength;
            this._lastRenderNodeType = renderNodeType;
            return;
        }
        if (this._lastRenderNodeType == renderNodeType) {
            this._lastbatch2DInfo.batch = !!(this._lastbatch2DInfo.batchFun);
            this._lastbatch2DInfo.elementLenth += elementLength;
        }
        else {
            this._batchInfoList.add(this._lastbatch2DInfo);
            this._lastbatch2DInfo = Batch2DInfo.create();
            this._lastbatch2DInfo.batch = false;
            this._lastbatch2DInfo.batchFun = RenderManager2D._batchMapManager[renderNodeType];
            this._lastbatch2DInfo.indexStart = this._renderElementList.length;
            this._lastbatch2DInfo.elementLenth = elementLength;
            this._lastRenderNodeType = renderNodeType;
        }
    }
    endRender() {
        this.clearList();
        this._renderEnd = true;
        this._lastRenderNodeType = -1;
    }
}
RenderManager2D._batchMapManager = {};
